/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import router from "./router";
import history from "../utils/history";
import environment from "../modules/environment";
import lystAppHandler from "./handlers/lyst-app-handler";
import searchHandler from "./handlers/search-handler";
import catchAllHandler from "./handlers/catch-all-handler";
import fullscreenGalleryHandler from "./handlers/fullscreen-gallery-handler";
import productOverlayHandler from "./handlers/product-overlay-handler";
import signupOverlayHandler from "./handlers/signup-overlay-handler";

export const DIGIT_REGEX = /^\d*$/;

function getURLPattern(patternName) {
    return environment.get("urlPatterns")[patternName];
}

function getProductPageRegexPattern() {
    // Note: the product slug regex pattern is a little different to Python.
    // JavaScript: [%-\w]+
    // Python:     [-\w]+
    //
    // This is because JavaScript is reading an encoded URL –
    // where Unicode characters are escaped with "%" to make an ASCII string.
    // Furthermore – in JavaScript "\w" would only match ASCII characters anyway.
    //
    // In contrast – Python WSGI provides decoded URLs, without %xx escapes,
    // and the Django URL resolver operates on such URLs.
    // In Python "\w" matches any Unicode characters considered alphanumeric.
    return `^/?(${getURLPattern("productType")})/([%-\\w]+)/$`;
}

let productPageRegex = null;
export function getProductPageRegex() {
    if (productPageRegex === null) {
        productPageRegex = new RegExp(getProductPageRegexPattern());
    }
    return productPageRegex;
}

export function getSearchURL() {
    return `${getURLPattern("search")}/`;
}

// todo i18n urls - get these patterns from the server.
export const SIGNUP_PAGE_REGEX = /^\/?(account)\/(register|login)\/$/;

function setup() {
    history.on("change", (event, data) => {
        // get the uuid for this history entry
        const uuid = data.state.uuid;

        if (environment.hasState(uuid)) {
            // if we have some environment state saved under this uuid then load it
            environment.loadState(uuid);
        } else {
            // else create a new saved state under this uuid
            environment.saveState(uuid);
        }

        router.update(data.path, data.query);
    });

    router.map(match => {
        match("/", {}, lystAppHandler, match => {
            match(getSearchURL(), {}, searchHandler);

            match(SIGNUP_PAGE_REGEX, {}, signupOverlayHandler);

            match(getProductPageRegex(), {}, productOverlayHandler, match => {
                match(null, { product_gallery: DIGIT_REGEX }, fullscreenGalleryHandler);
            });

            match(".*", {}, catchAllHandler);
        });
    });

    history.start();
}

export default {
    setup: setup
};

